/* eslint-disable better-mutation/no-mutation */
import { createSlice } from '@reduxjs/toolkit';
import {
    mapItemDetails,
    translatedDescriptionStates
} from '../view-item/reducer';

type TraderaShopSlice = {
    product: object;
    itemDetails: object;
    isLoading: boolean;
    sellerItems?: [];
    translatedDescription: object | null;
    translatedDescriptionState: string | null;
    currentDescriptionLanguageCodeIso2: string | null;
};

const traderaShopSlice = createSlice({
    name: 'traderaShop',
    initialState: {} as Partial<TraderaShopSlice>,
    reducers: {
        setIsLoading: (state, { payload }) => {
            state.isLoading = payload;
        },
        setItemDetails: (state, { payload }) => {
            state.itemDetails = mapItemDetails(payload);
        },
        setProduct: (state, { payload }) => {
            state.product = payload;
        },
        setSellerItems: (state, { payload }) => {
            state.sellerItems = payload;
        },
        setCurrentDescriptionLanguageCodeIso2: (state, { payload }) => {
            state.currentDescriptionLanguageCodeIso2 = payload;
        },
        setTranslationOnDemandDisabled: (state) => {
            state.translatedDescription = null;
            state.translatedDescriptionState =
                translatedDescriptionStates.TRANSLATION_ON_DEMAND_DISABLED;
        },
        setTranslatedDescription: (state, { payload }) => {
            state.translatedDescription = payload;
            state.translatedDescriptionState =
                translatedDescriptionStates.DEFAULT;
        },
        resetTranslatedDescription: (state) => {
            state.translatedDescription = null;
            state.translatedDescriptionState =
                translatedDescriptionStates.DEFAULT;
        },
        beginLoadingTranslatedDescription: (state) => {
            state.translatedDescription = null;
            state.translatedDescriptionState =
                translatedDescriptionStates.LOADING;
        },
        failedLoadingTranslatedDescription: (state) => {
            state.translatedDescriptionState =
                translatedDescriptionStates.SERVER_ERROR;
        }
    }
});

export default traderaShopSlice.reducer;

export const {
    setIsLoading,
    setItemDetails,
    setProduct,
    setSellerItems,
    setCurrentDescriptionLanguageCodeIso2,
    setTranslationOnDemandDisabled,
    setTranslatedDescription,
    resetTranslatedDescription,
    beginLoadingTranslatedDescription,
    failedLoadingTranslatedDescription
} = traderaShopSlice.actions;
